import { HOST_ACTION_INTENT_ORDER as e } from "./types/HostActionIntent.mjs";
import { sortActionsBy as t } from "./rankActions.mjs";
//#region src/sortHostActions.ts
var n = (n) => t(n, (t) => ({
	order: e[t.intent],
	expiresAt: t.expiresAt,
	createdAt: t.createdAt,
	weight: t.weight
}));
//#endregion
export { n as sortHostActions };
